import resellersModule from '../resellersModule.js';

function resaleService(resellersConstants, $q, $filter, httpService) {
    'ngInject';

    const setResalePrice = function (assetId, userAssetId, price) {
        const config = {
            url: $filter('formatString')(resellersConstants.urls.setResalePrice, { assetId, userAssetId })
        };
        
        return $q((resolve, reject) => {
            return httpService
                .httpPatch(config, { price })
                .then(resolve)
                .catch(httpService.getApiErrorCodeHandler(reject, resellersConstants.errorCodes.economyApi));
        });
    };

    return {
        getAssetResaleData(assetId) {
            const config = {
                url: $filter('formatString')(resellersConstants.urls.getResaleData, { assetId })
            };

            return $q((resolve, reject) => {
                return httpService
                    .httpGet(config, {})
                    .then(resolve)
                    .catch(httpService.getApiErrorCodeHandler(reject, resellersConstants.errorCodes.economyApi));
            });
        },

        getResellers(assetId, pagingParameters) {
            const config = {
                url: $filter('formatString')(resellersConstants.urls.getResellers, { assetId })
            };

            const queryParameters = {
                cursor: pagingParameters.cursor,
                limit: pagingParameters.count
            };

            return $q((resolve, reject) => {
                return httpService
                    .httpGet(config, queryParameters)
                    .then(resolve)
                    .catch(httpService.getApiErrorCodeHandler(reject, resellersConstants.errorCodes.economyApi));
            });
        },

        takeOffSale(assetId, userAssetId) {
            return setResalePrice(assetId, userAssetId, null);
        },

        setResalePrice(assetId, userAssetId, price) {
            return setResalePrice(assetId, userAssetId, price);
        }
    };
}

resellersModule.factory('resaleService', resaleService);
export default resaleService;
